// extracted by mini-css-extract-plugin
export default {"wrapper":"TableSection_wrapper__7w3e8","table":"TableSection_table__3STYa"};